// Mirror of the BE `archive.is_junk_filename` (src/inrange_agents/archive.py):
// OS / editor cruft and transient lock files that are never a real document and
// must never be attached to a project. Used to filter picked files client-side
// so a `~$` Office lock file (or a `.DS_Store` swept up when a folder is dropped)
// is never even uploaded. Keep the two in lock-step.
export const isJunkFilename = (name: string): boolean => {
  const base = name.split(/[\\/]/).pop() ?? name;
  if (base.startsWith("._")) return true; // macOS AppleDouble sidecar
  if (base.startsWith("~$")) return true; // MS Office owner / lock file
  if (base.startsWith(".~lock.") && base.endsWith("#")) return true; // LibreOffice lock
  return [".ds_store", "thumbs.db", "desktop.ini"].includes(base.toLowerCase());
};
